import React from 'react';

interface Props {
  totalPositions: number;
  totalUnrealizedPnl: number | null;
  platformCount: number;
}

const PositionSummary: React.FC<Props> = ({ totalPositions, totalUnrealizedPnl, platformCount }) => {
  const pnlClass = totalUnrealizedPnl === null ? '' : totalUnrealizedPnl >= 0 ? 'green' : 'red';
  const pnlSign = totalUnrealizedPnl !== null && totalUnrealizedPnl >= 0 ? '+' : '';

  return (
    <div className="pos-summary">
      <div className="pos-summary-card">
        <div className="pos-s-label">Open Positions</div>
        <div className="pos-s-val">{totalPositions}</div>
        <div className="pos-s-sub">{platformCount} platform{platformCount !== 1 ? 's' : ''}</div>
      </div>

      <div className="pos-summary-card">
        <div className="pos-s-label">Unrealized PnL</div>
        <div className={`pos-s-val ${pnlClass}`} id="pos-total-pnl">
          {totalUnrealizedPnl === null
            ? '—'
            : `${pnlSign}$${Math.abs(totalUnrealizedPnl).toFixed(2)}`}
        </div>
        {totalUnrealizedPnl !== null && (
          <div className={`pos-s-change ${pnlClass}`}>
            {totalUnrealizedPnl >= 0 ? '▲' : '▼'} Live
          </div>
        )}
      </div>

      <div className="pos-summary-card">
        <div className="pos-s-label">Today Realized</div>
        <div className="pos-s-val">—</div>
        <div className="pos-s-sub">Check History</div>
      </div>
    </div>
  );
};

export default PositionSummary;
